import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import { api } from "@/lib/api";
import { PlanMap } from "@/components/PlanMap";

export default function Outings() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/outings").then((r) => setData(r.data)); }, []);
  const s = data?.stats || {};
  return (
    <div className="max-w-6xl mx-auto px-5 py-10 lg:py-14 space-y-8" data-testid="outings-page">
      <div>
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#23603F]">Your journal · private</p>
        <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold tracking-tight">My Outings</h1>
        <p className="mt-2 text-stone-600 max-w-xl">The places you've actually been. Your map fills in a little more each time you head out.</p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {[["Outings", s.outings], ["Places visited", s.places], ["New discoveries", s.new_places], ["Kinds of places", s.categories]].map(([k, v]) => (
          <div key={k} className="rounded-2xl bg-white border border-stone-200 p-5" data-testid={`outings-stat-${k.split(" ")[0].toLowerCase()}`}>
            <p className="text-4xl font-extrabold text-[#163A2B]" style={{ fontFamily: "Outfit" }}>{v ?? "–"}</p>
            <p className="text-xs uppercase tracking-wider text-stone-500 mt-1">{k}</p>
          </div>
        ))}
      </div>
      <div className="h-[380px] rounded-3xl overflow-hidden border border-stone-200 relative z-0" data-testid="discovery-map">
        <PlanMap dots={data?.places || []} />
      </div>
      <section className="space-y-3">
        <h2 className="text-xl sm:text-2xl font-bold">Timeline</h2>
        {data?.outings.length === 0 && (
          <div className="rounded-2xl border border-dashed border-stone-300 p-8 text-center" data-testid="outings-empty">
            <p className="text-stone-600">No outings yet. After you go out, tap “We went! How was it?” on your plan.</p>
            <Link to="/" className="mt-3 inline-block font-semibold text-[#23603F]">Plan something →</Link>
          </div>
        )}
        {data?.outings.map((o, i) => (
          <div key={o.id} data-testid={`outing-entry-${i}`} className="rounded-2xl bg-white border border-stone-200 p-5 flex flex-col sm:flex-row sm:items-center gap-3">
            <div className="flex-1 min-w-0">
              <p className="font-mono text-xs text-stone-500">{new Date(o.completed_at).toLocaleDateString(undefined, { weekday: "short", month: "short", day: "numeric" })}</p>
              <h3 className="font-bold text-lg">{o.title}</h3>
              <p className="text-sm text-stone-600 truncate">{o.stops.map((x) => x.name).join(" · ")}</p>
              {o.note && <p className="text-sm italic text-stone-500 mt-1">“{o.note}”</p>}
            </div>
            <div className="flex items-center gap-3">
              {o.new_places > 0 && <span className="text-xs font-semibold bg-[#E3EFE6] text-[#0F2A1F] rounded-full px-2.5 py-1">+{o.new_places} new</span>}
              <span className="flex">{[1, 2, 3, 4, 5].map((n) => <Star key={n} className={`w-4 h-4 ${n <= o.rating ? "fill-amber-400 text-amber-400" : "text-stone-200"}`} />)}</span>
            </div>
          </div>
        ))}
      </section>
    </div>
  );
}
